import BaseDialog from '@/components/ui/BaseDialog';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useToggleApLock } from '@/hooks/registration/useToggleApLock';

const ToggleApLockDialog = () => {
    const { t } = useTranslation('common');

    const {
        state,
        checkState,
        confirmMessage,
        closeApLockDialog,
        confirmApLockChange,
        handleCheckChange,
        resetCheckState,
        title,
    } = useToggleApLock();

    return (
        <BaseDialog
            open={state.dialogState.isApLockOpen}
            dialogTitle={title}
            confirmButtonText={t('OK')}
            cancelButtonText={t('Cancel')}
            onConfirm={confirmApLockChange}
            onClose={closeApLockDialog}
            TransitionProps={{
                onExited: resetCheckState,
            }}
        >
            <Box>
                <Typography>{confirmMessage}</Typography>

                {state.apLockInfo.isLock && (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkState.enableWakeUp}
                                    onChange={handleCheckChange('enableWakeUp')}
                                />
                            }
                            label={t('Enable wake up')}
                        />
                    </Box>
                )}
            </Box>
        </BaseDialog>
    );
};

export default ToggleApLockDialog;
